import { render, staticRenderFns } from "./InputCopyContent.vue?vue&type=template&id=f73ab97e&scoped=true&"
import script from "./InputCopyContent.vue?vue&type=script&lang=js&"
export * from "./InputCopyContent.vue?vue&type=script&lang=js&"
import style0 from "./InputCopyContent.vue?vue&type=style&index=0&id=f73ab97e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73ab97e",
  null
  
)

export default component.exports